import axios from "axios";

const BASE_URL = "https://biensalud.pe";
const API_URL = BASE_URL + "/api";
export const API_URL_IMG = BASE_URL + "/public/fondos/";
export const API_START_RECORD = API_URL + "/agora/startRecord";

export const httpClient = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});
